export default __webpack_public_path__ + "static/media/s4_title.3da6689f.png";